import React from 'react'
import { Menu, Transition } from '@headlessui/react'
import { Typography } from '@corecomponents/ui'
import cn from 'clsx'
import s from '@styles/ui/Dropdown/Dropdown.module.css'

interface Props {
  trigger: any
  items: Item[]
  stretched?: boolean
  onSelect: (k: string) => void
}

interface Item {
  name: string
  key: string
  icon?: any
  hoverColor?: string
}

const Dropdown = ({ trigger, stretched, items, onSelect }: Props) => {
  const rootClassName = cn(s.root, { [s.stretched]: stretched })
  return (
    <div className={'relative'}>
      <Menu>
        <Menu.Button className={rootClassName}>{trigger}</Menu.Button>
        <Transition
          enter="transition duration-100 ease-out"
          enterFrom="transform scale-95 opacity-0"
          enterTo="!transform !scale-100 !opacity-100 !relative !z-20"
          leave="transition duration-75 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <Menu.Items
            className={cn(
              'absolute max-h-[300px] overflow-y-auto right-0 bg-white  shadow-all-round-strong rounded-md p-2 space-y-1 scrollbar-hide z-20',
              {
                ['w-[200px] max-h-80 overflow-scroll']: !stretched,
                ['w-full max-h-80 overflow-scroll']: stretched,
              }
            )}
          >
            {/*{({ active }) => (*/}
            {items.map((item) => {
              return (
                <Menu.Item key={item.name}>
                  <div
                    onClick={() => onSelect(item.key)}
                    className={`cursor-pointer rounded-md hover:bg-primary hover:text-white py-1 px-4 transition-colors duration-300 flex`}
                  >
                    {item?.icon && (
                      <img src={item?.icon} height={24} width={24}></img>
                    )}
                    <Typography variant={'regular'} weight={600}>
                      {item.name}
                    </Typography>
                  </div>
                </Menu.Item>
              )
            })}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}
export default Dropdown
